export default "__VITE_ASSET__BUEVLP3i__"